// form
import { FormProvider as Form, UseFormReturn } from 'react-hook-form';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
  methods: UseFormReturn<any>;
  onSubmit?: VoidFunction;
  id?: string;
  name?: string;
};

export default function FormProvider({ name, id, children, onSubmit, methods }: Props) {
  return (
    <Form {...methods}>
      <form name={name} id={id} onSubmit={onSubmit}>
        {children}
      </form>
    </Form>
  );
}
